import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
    {
        name: 'form-submit-mutate',
        props: true,
        path: '/form-submit-mutate/:id',
        component: () => LazyLoadView(import(/* webpackChunkName: "form-submit-mutate" */ '@/views/FormSubmit/Mutate.vue')),
        beforeEnter: isAuthenticated,
    },
    {
        name: 'form-submit-file',
        props: true,
        path: '/form-submit-file',
        component: () => LazyLoadView(import(/* webpackChunkName: "form-submit-file" */ '@/views/FormSubmit/File.vue')),
        beforeEnter: isAuthenticated,
        meta: {
            navigation: false,
            footer: false,
        },
    },

]


